/**
 * Whether the page's first hydration is over. _app marks it after its first commit; anything mounted later
 * (client navigation) has no server HTML to reuse.
 */
let hydrated = false

export const markAppHydrated = () => {
  hydrated = true
}

export const isAppHydrated = () => hydrated
